import { useMemo } from "react";

const useEvaluateParameters = ({ parameters }) => {
   return useMemo(() => {
      const result = {};
      if (!parameters || typeof parameters !== "string") return result;

      const pairs = parameters.trim().split(/\s+/);
      for (const pair of pairs) {
         const [key, value] = pair.split("=");

         if (key && value !== undefined) {
            const num = Number(value);
            if (!isNaN(num)) {
               result[key.trim()] = num;
            } else if (value === "true" || value === "false") {
               result[key.trim()] = value === "true";
            } else {
               result[key.trim()] = value.trim();
            }
         }
      }
      return result;
   }, [parameters]);
};

export default useEvaluateParameters;
